window.FormGenericValidator={
    required: function (v) {
        return v.toString().length>0;
    },
    email: function (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    },
    emailExists: function (email,validate_url,action) {
        let self=this;
        return new Promise((resolve,reject) => {
            $.ajax({
                method: "POST",
                async: false,
                dataType: "json",
                url: validate_url,
                data: {
                    email: email,
                    action: action
                },
                success: (data) => {
                    setTimeout(()=>{
                        resolve((data.retorno != "existe"));
                    });
                },
                error: (e) => {
                    alert("UM ERRO OCORREU. FAVOR INFORMAR AO NOSSO SUPORTE.");
                    reject(e);
                }
            });
        });
    },
    password: (password) => {
        return (password.length>=6);
    },
    passwordConfirm: (pass,pass_confirm) => {
        return (pass==pass_confirm);
    },
    birthday: (date) => {
        let dateOnlyNumbersArray=date.toString().match(/([0-9])/g);
        return dateOnlyNumbersArray.length==8;
    },
    dateGreater: (date1,date2) => {
        if(date1.year>date2.year){
            return 1;
        }
        else if(date1.year==date2.year){
            if(date1.month>date2.month){
                return 1;
            }
            else if(date1.year==date2.year){
                if(date1.day>date2.day){
                    return 1;
                }
                else if(date1.year==date2.year){
                    return 0;
                }
                else{
                    return -1;
                }
            }
            else{
                return -1;
            }
        }
        else{
            return -1;
        }
    },
    dateValid: (date) => {
        return (
            (date.day>=1 && date.day<=31) &&
            (date.month>=1 && date.month<=12)
        );
    },
    cpf:(cpf) => {
        cpf =  cpf.replace(/\.|\-/g, '');

        var numeros, digitos, soma, i, resultado, digitos_iguais;
        digitos_iguais = 1;
        if (cpf.length < 11)
            return false;
        for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1))
            {
                digitos_iguais = 0;
                break;
            }
        if (!digitos_iguais)
        {
            numeros = cpf.substring(0,9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--)
                soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;
            numeros = cpf.substring(0,10);
            soma = 0;
            for (i = 11; i > 1; i--)
                soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            return resultado == digitos.charAt(1);

        }
        else
            return false;


    },
    cnpj: (cnpj) =>  {
            cnpj = cnpj.replace(/[^\d]+/g,'');

            if(cnpj == '') return false;

            if (cnpj.length != 14) return false;

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999") return false;

            // Valida DVs
            let tamanho = cnpj.length - 2,
                numeros = cnpj.substring(0,tamanho),
                digitos = cnpj.substring(tamanho),
                soma = 0,
                pos = tamanho - 7,
                i=0;

            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }

            let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

            if (resultado != digitos.charAt(0)) return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;

            return true;
        }
};